import { useEffect } from 'react';
import { useSetAtom, useAtomValue } from 'jotai';
import { currentUserAtom, authLoadedAtom } from './AuthAtoms';
import { fetchUserDetails } from '../api/auth';
import { triggerFatigueHeal } from '../api/fatigue';
import { userItemsAtom } from '../atoms/itemAtoms';

const AuthInitializer = () => {
    const setCurrentUser = useSetAtom(currentUserAtom);
    const setAuthLoaded = useSetAtom(authLoadedAtom);
    // Subscribe to warm up the fetch as soon as currentUserAtom is set
    useAtomValue(userItemsAtom);

    useEffect(() => {
        const initializeAuth = async () => {
            const accessToken = localStorage.getItem('accessToken');
            if (accessToken) {
                try {
                    const userDetails = await fetchUserDetails(accessToken);
                    if (userDetails?.user) {
                        setCurrentUser(userDetails.user);
                        triggerFatigueHeal(); // fire-and-forget: covers sessions that never re-login
                    }
                } catch (error) {
                    console.error('Error fetching user details:', error);
                }
            }
            setAuthLoaded(true);
        };

        initializeAuth();
    }, [setCurrentUser, setAuthLoaded]);

    return null; // No UI needed for this component
};

export default AuthInitializer;
